import React, { useEffect } from 'react';
import { AmpNavigation } from '@amplify/amp-navigation';
import PropTypes from 'prop-types';
import { useKeycloak } from '@react-keycloak/web';
import { jwtDecode } from 'jwt-decode';
import KeycloakClient from '../../api/clients/shared/KeycloakClient';
import './AmpNavWrapper.scss';

const AmpNavWrapper = ({ staffConfig, isStaffConfigFetched, fetchStaffConfig, isDemoModeOn }) => {
    const { keycloak } = useKeycloak();
    const tokenData = jwtDecode(KeycloakClient.getToken());
    const keycloakData = {
        _keycloak: {
            ...keycloak,
            userInfo: {
                ...tokenData,
                userId: tokenData.mclassUserSid,
                realmAccess: tokenData.realm_access,
            },
        },
    };

    useEffect(() => {
        if (!isStaffConfigFetched) {
            fetchStaffConfig();
        }
    }, []);

    return (
        isStaffConfigFetched && (
            <>
                <div className={`amp-nav-wrapper no-print ${isDemoModeOn ? 'in-demo' : ''}`}>
                    <div className="hidden-wrapper-buffer">
                        <AmpNavigation config={{ ...staffConfig, ...keycloakData }} />
                    </div>
                </div>
            </>
        )
    );
};

AmpNavWrapper.defaultProps = {
    isStaffConfigFetched: false,
    staffConfig: {},
    fetchStaffConfig: () => {},
    isDemoModeOn: false,
};

AmpNavWrapper.propTypes = {
    isStaffConfigFetched: PropTypes.bool,
    staffConfig: PropTypes.object,
    fetchStaffConfig: PropTypes.func,
    isDemoModeOn: PropTypes.bool,
};

export default AmpNavWrapper;
